import { useAppContext } from '../contexts/app-context'

const useDiscountSettings = () => {
  const { appContext } = useAppContext()
  return appContext.discountSettings
}

export default useDiscountSettings
